import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';


@Directive({
    selector: '[appRepeatOf]',
    standalone: false
})
export class RepeatDirective {

  constructor(private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef) {
  }

  @Input()
  set appRepeatOf(times: number) {
    const initialLength = this.viewContainer.length;
    const diff = times - initialLength;

    if (diff > 0) {
      for (let i = initialLength; i < initialLength + diff; i++) {
        this.viewContainer.createEmbeddedView(this.templateRef, {
          $implicit: i
        });
      }
    } else {
      for (let i = initialLength - 1; i >= initialLength + diff; i--) {
        this.viewContainer.remove(i);
      }
    }
  }
}
